// extracted by mini-css-extract-plugin
export var itemIcon = "style-module--item-icon--86dbb";
export var itemLogo = "style-module--item-logo--0ecf7";
export var newLabel = "style-module--new-label--edf82";
export var subcaption = "style-module--subcaption--69618";
export var sublabel = "style-module--sublabel--f2f1c";
export var sublink = "style-module--sublink--63918";
export var sublinkGrid = "style-module--sublink--grid--ad757";
export var sublinkHighlighted = "style-module--sublink--highlighted--0ca99";
export var sublinkNoBorder = "style-module--sublink--no-border--fd828";